export default {
  index: {
    updateInformationTo: '更新信息到ONCALL失败, 请稍后再试',
  },
};
